export const Axios_Route = {
  
  GET_OTP:'user/GenerateOtp',
  VERIFY_OTP:'user/VerifyOtp',
  FORGET_PASSWORD:'User/ForgetPassword',
  DASHBOARD_INDEX:'Home/Index',
  CHANGE_PASSWORD:'User/ChangePassword',

  USER_INFO:'User/GetUserInfo',

  CONTACT_AGENT_REQUEST:'Message/List',
  CONTACT_AGENT_REQUEST_DELETE:'Message/Delete',
  RENTAL_LIST:'Rental/List',
  RENTAL_DELETE:'Rental/Delete',
  SUBMITED_PROPERTY_LIST:'Request/List',
  CONTACT_AGENT_DELETE:'Request/Delete',

  PROPERTY_LIST_SEARCH_BASE:'deposit/searchbase',
  PROPERTY_LIST_SEARCH_BASE_PROPERTY_SIZE:'deposit/getBuildingAreaRange?propertyId=',
  PROPERTY_LIST_SEARCH_BASE_PRICE_RANGE:'deposit/getpriceRange?propertyId=',

  DEPOSITE_SEARCH:'deposit/search',
  DEPOSITE_STATUS:'Deposit/Status',
  DEPOSITE_LIST_WITH_PAGE:'deposit/list',
  DEPOSITE_ADD_INDEX:'deposit/index',
  DEPOSITE_ADD:'deposit/Add',
  DEPOSITE_EDIT:'deposit/edit',
  DEPOSITE_CHANGE_STATUS:'deposit/ChangeState',
  DEPOSITE_UPLOAD_IMAGE:'File/uploadimage',

  LIST_AGENT:'User/List',
  LIST_AGENT_SEARCH:'User/Search',

  GET_USER_ROLE:'User/Getrole',
  ADD_USER:'User/Add',
  EDIT_USER:'User/edit',
  UPLOAD_USER_IMAGE:'File/UploadImageUser',

  REGION_LIST:'Region/List',
  EDIT_REGION_SORT:'Region/Sort',

  Add_REGION:'Region/Add',
  EDIT_REGION:'Region/Edit',

  BASE_INFO:'BaseInfo/List',
  FACILITY_LIST:'Facility/List',
  FACILITY_ADD:'Facility/Add',
  BASE_INFO_ADD:'BaseInfo/Add',
  BASE_EDIT:'BaseInfo/Edit',
  FACILITY_EDIT:'Facility/Edit',

  ABOUT_US:'AboutUs/List',
  ABOUT_US_EDIT:'AboutUs/Edit',
}